export const VerticalPlugin = {
  install: (Vue) => {
    const ALL_VERTICALS = [
      {
        id: 'concursos',
        color: '#6E58CD',
        title: 'Estratégia Concursos <span class="c-text-btn" style="color: #6E58CD; font-size: 18px;">Novo</span>',
        description: 'Nova plataforma para preparação em Concursos.',
        url: Vue.env.VUE_APP_CONCURSOS_WEB_URL,
        enabled: true,
      },
      {
        id: 'concursos-legado',
        color: '#6E58CD',
        title: 'Estratégia Concursos <span class="c-text-btn" style="color: #6E58CD; font-size: 18px;">(Antigo)</span>',
        description: 'Versão antiga da plataforma de Concursos.',
        url: ({ token }) => Vue.env.VUE_APP_CONCURSOS_LEGADO_WEB_URL + `?access_token=${token}`,
        enabled: true,
      },
      {
        id: 'medicina',
        color: '#0BA4AE',
        title: 'Estratégia MED',
        description: 'Conteúdos e ferramentas para Residência Médica e Revalida.',
        url: Vue.env.VUE_APP_MEDICINA_WEB_URL,
        enabled: true,
      },
      {
        id: 'vestibulares',
        color: '#FF970D',
        title: 'Estratégia Vestibulares',
        description: 'Conteúdos e ferramentas para ENEM e vestibulares.',
        url: Vue.env.VUE_APP_VESTIBULARES_WEB_URL,
        enabled: true,
      },
      {
        id: 'militares',
        color: '#3F7E67',
        title: 'Estratégia Militares',
        description: 'Conteúdos e ferramentas para carreiras militares.',
        url: Vue.env.VUE_APP_MILITARES_WEB_URL,
        enabled: true,
      },
      {
        id: 'carreiras-juridicas',
        color: '#A36B00',
        title: 'Estratégia Carreira Jurídica',
        description: 'Conteúdos e ferramentas para carreiras jurídicas.',
        url: Vue.env.VUE_APP_CARREIRAS_JURIDICAS_WEB_URL,
        enabled: true,
      },
      {
        id: 'carreiras-juridicas-legado',
        color: '#A36B00',
        title: 'Estratégia Carreira Jurídica <span class="c-text-gray-300">(Antigo)</span>',
        description: 'Versão antiga da plataforma de Carreiras Jurídicas.',
        url: ({ token }) => Vue.env.VUE_APP_CONCURSOS_LEGADO_WEB_URL + `?access_token=${token}`,
        enabled: false,
      },
      {
        id: 'oab',
        color: '#AE0A0B',
        title: 'Estratégia OAB',
        description: 'Conteúdos e ferramentas para o Exame de Ordem.',
        url: Vue.env.VUE_APP_OAB_WEB_URL,
        enabled: true,
      },
    ];

    // Indexa as verticais
    const verticalsMap = ALL_VERTICALS.reduce((acc, vertical) => {
      acc[vertical.id] = vertical;
      return acc;
    }, {});

    Vue.prototype.$vertical = {
      getEnabled: () => ALL_VERTICALS.filter((v) => v.enabled),
      getById: (id) => verticalsMap[id],
      getTitleById: (id) => verticalsMap[id]?.title,
      getUrl: (id) => verticalsMap[id]?.url,
    };
  },
};
